(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 768px)';

  // Mirror the cart total from the footer into the sticky bar so both stay identical.
  function syncTotals() {
    document.querySelectorAll('[data-as-br-0010-sticky-checkout]').forEach(function (bar) {
      var target = bar.querySelector('[data-as-br-0010-total]');
      var section = bar.closest('.shopify-section') || document;
      var source = section.querySelector('[data-as-br-0010-total-source]');

      if (target && source) {
        target.textContent = source.textContent.trim();
      }
    });
  }

  function initBar(bar) {
    if (bar.dataset.asBr0010Ready) {
      return;
    }
    bar.dataset.asBr0010Ready = 'true';

    var section = bar.closest('.shopify-section') || document;
    var anchor = section.querySelector('[data-as-br-0010-anchor]');

    if (!anchor) {
      return;
    }

    // Reveal the sticky bar once the regular checkout button is scrolled out of view.
    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    });

    var mediaQuery = window.matchMedia(MOBILE_QUERY);

    function sync() {
      if (mediaQuery.matches) {
        observer.observe(anchor);
      } else {
        observer.unobserve(anchor);
        bar.classList.remove('is-visible');
      }
    }

    mediaQuery.addEventListener('change', sync);
    sync();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-as-br-0010-sticky-checkout]').forEach(initBar);
  }

  function refresh(root) {
    initAll(root);
    syncTotals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refresh();
    });
  } else {
    refresh();
  }

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target);
  });

  // Re-init and re-sync when the cart is updated (quantity change, item removal, ...).
  document.addEventListener('cart:change', function () {
    requestAnimationFrame(function () { refresh(); });
  });
  document.addEventListener('cart:refresh', function () {
    requestAnimationFrame(function () { refresh(); });
  });
})();
